import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { BusquedaTesoroCofrePage } from './busqueda-tesoro-cofre';
import { IonicImageViewerModule } from 'ionic-img-viewer';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
  declarations: [
    BusquedaTesoroCofrePage,
  ],
  imports: [
    IonicPageModule.forChild(BusquedaTesoroCofrePage),
    IonicImageViewerModule,
    ComponentsModule
  ],
})
export class BusquedaTesoroCofrePageModule {}



// WEBPACK FOOTER //
// ./src/pages/busqueda-tesoro-cofre/busqueda-tesoro-cofre.module.ts